/**
 * QUIPWA — is the app listening or speaking right now?
 *
 *   useSpeaking     which text a voice is reading (speaker.ts, reader.ts)
 *   useMicrophone   how many microphones are open (capture.ts, recorder.ts)
 *
 * Apart from the speech code (and its worker) so that whatever must keep
 * quiet meanwhile can ask without loading it: the Fichero skin's sounds
 * (lib/sound) never play while a microphone is open, because it would pick
 * them up, nor over a voice reading.
 */
import { create } from 'zustand'

/** Which text is being read now, so its button can show "stop". */
export const useSpeaking = create<{ id: string | null }>(() => ({ id: null }))

/** Microphones open now: capturing, even if their audio is not used yet. */
export const useMicrophone = create<{ open: number }>(() => ({ open: 0 }))

/** Counts an open microphone until the returned function releases it (once, however often it is called). */
export function holdMicrophone(): () => void {
  useMicrophone.setState((s) => ({ open: s.open + 1 }))
  let held = true
  return () => {
    if (!held) return
    held = false
    useMicrophone.setState((s) => ({ open: Math.max(0, s.open - 1) }))
  }
}
